import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from './use-toast';

export function useAuthWithRetry() {
  const [isLoading, setIsLoading] = useState(false);

  const signUpWithRetry = async (email: string, password: string, userData?: any) => {
    setIsLoading(true);
    
    try {
      console.log(`🔄 Cadastrando usuário: ${email}`);
      
      const { data, error } = await supabase.auth.signUp({
        email,
        password,
        options: {
          emailRedirectTo: `${window.location.origin}/auth?verified=true`,
          data: userData
        }
      });

      if (!error) {
        console.log('✅ Cadastro realizado com sucesso!');
        toast({
          title: "Cadastro realizado!",
          description: "Enviamos um e-mail de verificação. Confirme seu endereço de e-mail para ativar sua conta.",
          variant: "default"
        });
        setIsLoading(false);
        return { data, error: null };
      }

      // Retornar erro sem tentar novamente
      console.error('❌ Erro no cadastro:', error);
      setIsLoading(false);
      return { data: null, error };

    } catch (err: any) {
      console.error('❌ Erro no cadastro:', err);
      setIsLoading(false);
      return { data: null, error: err };
    }
  };

  const signInWithRetry = async (email: string, password: string) => {
    setIsLoading(true);
    
    try {
      console.log(`🔄 Fazendo login: ${email}`);
      
      const { data, error } = await supabase.auth.signInWithPassword({
        email,
        password
      });

      if (!error) {
        console.log('✅ Login realizado com sucesso!');
        setIsLoading(false);
        return { data, error: null };
      }

      console.error('❌ Erro no login:', error);
      setIsLoading(false);
      return { data: null, error };

    } catch (err: any) {
      console.error('❌ Erro no login:', err);
      setIsLoading(false);
      return { data: null, error: err };
    }
  };

  return {
    signUpWithRetry,
    signInWithRetry,
    isLoading
  };
}